import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    primary: {
      50: "#f7fafc",
      51: "#0D3B",
    },
    back: " #0D3B70",
    card: "#F5F8FF",
    backpay: "#E5F1FF",
    btn: "#093281",
    backinput: "#FFFFFF",
    help: "#B4B4B4",
    modal: "var(--Azul-Ingenes, var(--azul-Ingenes, #093281))",
  },
  fonts: {
    body: "Source Sans 3, sans-serif",
    heading: "Merriweather,sans-serif",
  },
  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
  },
  // Define otros estilos de fuente aquí
  // ...
  styles: {
    global: {
      body: {
        bg: "#E5F1FF",
      },
    },
  },
});

export default theme;
